import { z } from 'zod';

export type PaginationRequest<F extends object = Record<string, never>> =
  Partial<F> & {
    page?: number;
    search?: string;
    reloadPages?: boolean;
    itemsPerPage?: number;
  };

export const PaginationResponse = <T extends z.ZodTypeAny>(item: T) =>
  z.object({
    items: item.array(),
    currentPage: z.number(),
    totalPages: z.number(),
  });
export type PaginationResponse<T> = {
  items: T[];
  currentPage: number;
  totalPages: number;
};

export const FileActor = z.enum(['MERCHANT', 'TRADER']);
export type FileActor = z.infer<typeof FileActor>;

export const AggregationPeriod = z.enum([
  'DAY',
  'HOUR',
  'WEEK',
  'MONTH',
  'YEAR',
]);
export type AggregationPeriod = z.infer<typeof AggregationPeriod>;
